import React from "react";
import config from "../../utils/config";

import get from "lodash/get";

const _ = { get };

const Image = (props) => {
  let { alt, style, height, width, srcPath, elements } = props;
  return (
    <div
      className="moderationPreviewImg position-relative m-lg-auto"
      onClick={props.onClick}
    >
      <img
        src={`${config.imageBaseUrl}${srcPath}`}
        className="w-100"
        style={style}
        alt={alt}
        height={height}
        width={width}
      />

      <div className="overlay d-flex align-items-center justify-content-center">
        {/* onClick={props.openClick} */}
        <p className="previewText">
          {_.get(
            elements,
            "imageModerationListTableElement.previewLabelElement",
            "Preview"
          )}
        </p>
      </div>
    </div>
  );
};

export default Image;
